import styled from 'styled-components';
import { motion, useAnimation } from 'framer-motion';
import { transitionTween, stylesNoSelect } from 'Constants';

const SwitcherChanger = styled(motion.div)`
	height: 14px;
	overflow-y: hidden;
`;

export default SwitcherChanger;